import React from 'react';
import Create from './pages/Create';
import Edit from './pages/Edit';
import Index from './pages/Index';
import { AppRouteProps } from '~/routes';

export default function StationRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/station', component: Index, isProtected: true, permissions: ['station_index']},
    {path: '/station/create', component: Create, isProtected: true, permissions: ['station_create']},
    {path: '/station/edit/:id', component: Edit, isProtected: true, permissions: ['station_edit']},

  ];

  return routes;
}
